import styled from "styled-components";

export const FormComplaintStyle = styled.form`
  h2 {
    color: #111;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 32px;
  }
`;

export const FormFieldsAnonymous = styled.div`
  display: grid;
  gap: 24px;
  margin-bottom: 32px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: "check check" "nome nome" "data cargo" "setor setor";

    > div:nth-child(1) {
      grid-area: check;
    }
    > div:nth-child(2) {
      grid-area: nome;
    }
    > div:nth-child(3) {
      grid-area: data;
    }
    > div:nth-child(4) {
      grid-area: cargo;
    }
    > div:nth-child(5) {
      grid-area: setor;
    }
  }
`;

export const FormFieldsAccused = styled.div`
  display: grid;
  gap: 24px;
  margin-bottom: 32px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: "nome nome" "cargo setor" "tipo tipo";

    > div:nth-child(1) {
      grid-area: nome;
    }
    > div:nth-child(2) {
      grid-area: cargo;
    }
    > div:nth-child(3) {
      grid-area: setor;
    }
    > div:nth-child(4) {
      grid-area: tipo;
    }
  }
`;

export const FormFieldsDescription = styled.div`
  display: grid;
  gap: 24px;
  margin-bottom: 32px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: "data local" "descricao descricao";

    > div:nth-child(1) {
      grid-area: data;
    }
    > div:nth-child(2) {
      grid-area: local;
    }
    > div:nth-child(3) {
      grid-area: descricao;
    }
  }
`;

export const FormFieldsWitnesses = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "nome nome" "local local" ". buttom";
  margin-bottom: 32px;

  div:nth-child(1) {
    grid-area: nome;
  }
  div:nth-child(2) {
    grid-area: local;
  }
  div:nth-child(3) {
    grid-area: buttom;
    width: fit-content;
    margin-left: auto;
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 0.2fr;
    grid-template-areas: "nome local buttom";
    align-items: center;
  }
`;

export const WrapperCardsWitness = styled.div`
  margin-bottom: 32px;

  & > div + div {
    margin-top: 16px;
  }
`;

export const Questions = styled.div`
  margin-bottom: 24px;
`;

export const WrapperQuestion = styled.div`
  display: grid;
  gap: 16px;
  margin-bottom: 32px;

  p {
    color: #111;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    span {
      color: #e00;
    }
  }

  @media (min-width: 1024px) {
    display: flex;
    align-items: center;

    > :last-child {
      flex: 1;
    }
  }
`;

export const WrapperTextArea = styled.div`
  margin-bottom: 32px;
`;

export const FormFieldsRequest = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  grid-template-areas: "demanda demanda" "outras outras" ". button";

  > div:nth-child(1) {
    grid-area: demanda;
  }
  > div:nth-child(2) {
    grid-area: outras;
  }
  > div:nth-child(3) {
    grid-area: button;
    width: fit-content;
    margin-left: auto;
  }
`;
